"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
function useIsDarkMode() {
    var _a;
    var ref = (0, react_1.useRef)(typeof window !== 'undefined' ? window.matchMedia('(prefers-color-scheme: dark)') : null);
    var _b = (0, react_1.useState)(((_a = ref.current) === null || _a === void 0 ? void 0 : _a.matches) || false), isDarkMode = _b[0], setIsDarkMode = _b[1];
    (0, react_1.useEffect)(function () {
        var mediaQueryList = ref.current;
        if (!mediaQueryList)
            return;
        var onChange = function (event) {
            setIsDarkMode(event.matches);
        };
        mediaQueryList.addEventListener('change', onChange);
        return function () {
            mediaQueryList.removeEventListener('change', onChange);
        };
    }, []);
    return isDarkMode;
}
exports.default = useIsDarkMode;
